export const isPreviewFromEnv = (): boolean => {
  const envVal = process.env['NEXT_PUBLIC_IS_PREVIEW_ENABLED'];

  return envVal?.trim().toLowerCase() === 'true';
};
